import { Heading } from '@astryxdesign/core/Heading';
import { Lightbox } from '@astryxdesign/core/Lightbox';
import { VStack } from '@astryxdesign/core/VStack';
import { useState } from 'react';
import type { Studio } from '@/api/schemas';
import { mediaUrl } from '@/lib/supabase';

export function Gallery({ items }: { items: Studio['gallery'] }) {
  const [open, setOpen] = useState<number | null>(null);
  if (items.length === 0) return null;
  const media = items.map((g) => ({ src: mediaUrl(g.imagePath) ?? '', alt: g.caption || 'Пример работы', caption: g.caption }));
  return (
    <VStack gap={3} as="section" aria-labelledby="works-heading">
      <Heading level={2} id="works-heading">
        Наши работы
      </Heading>
      <ul className="snap-row">
        {items.map((g, i) => (
          <li key={g.id} className="snap-row__item snap-row__item--photo">
            <button type="button" className="work" onClick={() => setOpen(i)} aria-label={`Открыть фото: ${g.caption || 'пример работы'}`}>
              <img src={media[i]!.src} alt="" loading="lazy" decoding="async" width={320} height={240} />
              {g.caption && <span className="work__caption">{g.caption}</span>}
            </button>
          </li>
        ))}
      </ul>
      <Lightbox isOpen={open !== null} onOpenChange={(o) => !o && setOpen(null)} media={media} index={open ?? 0} onIndexChange={setOpen} hasZoom />
    </VStack>
  );
}
